import React, { useEffect, useState } from "react";
import "../../styles/style_partner.css";
import { API } from '../../api';

export default function Partners({ data }) {
  if (!data || data.length === 0) return null;

  const visibles = data.filter(p => p.isvisible);
  const total = visibles.length;

  return (
    <div className="slider-bas">
      <h1 className="titre-slider-bas">Ils nous font confiance</h1>

      <div className="wrapper1">
        {visibles.map((p, index) => {
          const delay = `calc(30s / ${total} * ${index} * -1)`;

          let backgroundImage = "";

          if (p.typesource === "local1") { // optimisation a remetre corectement en place ici plus tard \\
            backgroundImage = `
              -webkit-image-set(
                url(/images/confiance/avif/${p.imgname}.avif) type("image/avif") 1x,
                url(/images/confiance/webp/${p.imgname}.webp) type("image/webp") 1x,
                url(/images/confiance/source/${p.imgname}.${p.extension}) type("image/${p.extension}") 1x
              ),
              image-set(
                url(/images/confiance/avif/${p.imgname}.avif) type("image/avif") 1x,
                url(/images/confiance/webp/${p.imgname}.webp) type("image/webp") 1x,
                url(/images/confiance/source/${p.imgname}.${p.extension}) type("image/${p.extension}") 1x
              )
            `;
          } else backgroundImage = p.typesource === 'local' ? `url(${API.API_LINK}/file/pictures/partner/source/${p.imgname}.${p.extension})` : `url(${p.imgname})`;

          return (
            <a key={p.id} href="#">
              <div className="partner-item" style={{ backgroundImage, animationDelay: delay, }} />
            </a>
          );
        })}
      </div>
    </div>
  );
}
